<template src="./SubscribeQRCode.html"></template>
  <script>
  import store from "../../../store";
  import QRCode from "qrcodejs2"; //二维码
import loginService from '../../../plugin/extendFn/loginService';
  /**
   * 分享二维码
   */
  export default {
    data() {
      return {
        codeUrl:null,
        timer:null
      };
    },
    props: {},
    methods: {
        getTicket(){
            /**
             * 获取二维码的tiket
             * 
             */
            var userId= loginService.getUserId()
            // if(userId && userId>0)
            {
                this.$postHttp(`/ra-app/api/cmdhra/showqrcode/ticket/${userId}`).then(async (res) => {
                var code=res.data.code;
                var tiket=res.data.data;
                console.log(" getTicket >>> tiket=",tiket)
                if (code == 0 && tiket) {
                    this.codeUrl=`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${tiket}`
                    this.startTimer();
                }
                else{
                    this.$message.error("获取 tiket失败!")
                }
            })
            }
        },
        startTimer()
        {
          // 两秒中查询状态
          this.timer= setInterval(() => {
            this.getIsSubscribe();
          }, 1000 * 2);
        },
        getIsSubscribe(){
          var userId=loginService.getUserId();
          if(userId!=null && userId>0)
          {
            this.$postHttp(`/ra-app/api/cmdhra/isSubscribe/${userId}`).then(async (res) => {
                  // console.log("isSubscribe >>> res=", res)
                  var code = res.data.code;
                  var isSubscribe = res.data.data;
                  // 重新加载页面。
                  if (code == 0) {
                      if(isSubscribe==true)
                      {
                        // 已经关注
                        this.$router.push({
                          name:"Live" // 跳转到首页
                        })
                      }
                  }
              })
          }
        }
    },
    computed: {},
    async mounted() {
        this.getTicket();
    },
    beforeDestroy(){
      console.log("SubscribeQRCode >>>> unmounted")
      if(this.timer)
      {
        console.log("SubscribeQRCode >>>> 清除定时器!")
        clearInterval(this.timer);
        this.timer=null
      }
    }
  };
  </script>
  <style scoped lang="scss" src="./SubscribeQRCode.scss">  </style>
  


// WEBPACK FOOTER //
// src/components/me/SubscribeQRCode/SubscribeQRCode.vue